<template>
  <!-- 工单回复弹窗 -->
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="工单回复"
      width="400px"
      @close="closeDialog"
    >
      <el-form ref="replyForm" label-width="80px" size="small">
        <el-form-item prop="contentTitle" label="工单标题">
          <el-input :disabled="true" v-model="contentTitle"> </el-input>
        </el-form-item>
        <el-form-item prop="contentText" label="工单内容">
          <el-input
            type="textarea"
            maxlength="100"
            :rows="6"
            show-word-limit
            :disabled="true"
            v-model="contentText"
          >
          </el-input>
        </el-form-item>
        <el-form-item prop="replyText" label="回复内容">
          <el-input
            type="textarea"
            placeholder="请输入回复内容"
            maxlength="100"
            show-word-limit
            :disabled="orderStatus === 2"
            v-model="replyText"
          >
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="success" v-if="orderStatus === 1" @click="setSolve"
            >解决</el-button
          >
          <el-button @click="closeDialog">取消</el-button>
          <el-button
            v-if="orderStatus != 2"
            type="primary"
            @click="submit"
            :loading="buttonLoading"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { getData, delApiData, getApiData, postApiData, patchApiData } from '../../http'
export default {
  props: {
    visible: {//展示标志
      type: Boolean,
      default: false
    },
    value: {//数据
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      loading: false,//加载动画
      buttonLoading: false,//按钮加载动画\
      contentTitle: '',//工单标题
      contentText: '',//工单内容
      replyText: '',//回复内容
      orderStatus: 1,//订单状态
    }
  },
  computed: {
    ...mapState({
    }),
    dialogVisible: {
      get() {
        return this.visible
      },
      set() {
      }
    },
    orderInfo: {
      get() {
        return this.value
      },
      set() {
      }
    },
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        //获取订单状态，并拼接工单信息        
        this.orderStatus = this.orderInfo.status
        let textContent = '▷用户：' + this.orderInfo.content
        for (let i = 0; i < this.orderInfo.replies.length; i++) {
          if (this.orderInfo.replies[i].type === 1) {
            textContent = textContent + '\n▶客服：' + this.orderInfo.replies[i].reply
          } else {
            textContent = textContent + '\n▷用户：' + this.orderInfo.replies[i].reply
          }
        }
        this.contentText = textContent//工单内容
        this.contentTitle = this.orderInfo.title//工单名称
      }
    },
  },
  created() {
  },
  methods: {
    submit() {
      //保存任务
      //表单验证后发起请求
      if (!this.replyText) {
        this.$message.success('回复内容不能为空')
        return
      }
      this.buttonLoading = true
      let params = {
        status: this.orderInfo.status,
        reply: this.replyText
      }
      patchApiData(`repair_order_reply/${this.orderInfo.id}`, params).then(res => {
        this.$message.success('回复成功！')
        this.replyText = ''//回复置空
        this.$emit('refresh')
        this.closeDialog()
      }).finally(() => {
        this.buttonLoading = false
      })
    },
    setSolve() {
      //设置工单已解决
      this.$confirm('确定设此工单为已解决？', {
        type: 'warning'
      }).then(res => {
        let params = {
          reply: this.replyText
        }
        patchApiData(`repair_order_reply_status/${this.orderInfo.id}`, params).then(res => {
          this.$message.success('回复成功！')
          this.$emit('refresh')
          this.closeDialog()
        }).finally(() => {
        })
      })
    },
    closeDialog() {
      //关闭弹窗
      this.$emit("close")
    }
  }

}
</script>
<style lang="less" scoped>
</style>